var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlue1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#27b74e"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4335 27.4768C29.6959 27.4768 27.4766 29.6961 27.4766 32.4338V55.5663C27.4766 58.304 29.6959 60.5233 32.4335 60.5233H55.5661C58.3037 60.5233 60.523 58.304 60.523 55.5663V39.0431C60.523 36.8848 59.1437 35.0486 57.2184 34.3682V32.4338C57.2184 29.6961 54.9991 27.4768 52.2614 27.4768H32.4335ZM32.4335 30.7815C31.521 30.7815 30.7812 31.5212 30.7812 32.4338C30.7812 33.3463 31.521 34.0861 32.4335 34.0861H53.9137V32.4338C53.9137 31.5212 53.174 30.7815 52.2614 30.7815H32.4335ZM52.2614 44C50.4363 44 48.9568 45.4796 48.9568 47.3047C48.9568 49.1298 50.4363 50.6093 52.2614 50.6093H55.5661C56.4786 50.6093 57.2184 49.8696 57.2184 48.957V45.6524C57.2184 44.7398 56.4786 44 55.5661 44H52.2614Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlue1);
export default __webpack_public_path__ + "static/media/blue1.eeb57bb574b50cc094ea9da3b6658bad.svg";
export { ForwardRef as ReactComponent };